import { render, staticRenderFns } from "./company_detail.vue?vue&type=template&id=39459dd4&scoped=true&"
import script from "./company_detail.vue?vue&type=script&lang=js&"
export * from "./company_detail.vue?vue&type=script&lang=js&"
import style0 from "./company_detail.vue?vue&type=style&index=0&id=39459dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39459dd4",
  null
  
)

export default component.exports